module.exports = __webpack_public_path__ + "img/20191008160353360截图20191008143514945.34cc66a5.jpg";